import { render, staticRenderFns } from "./vat-currentStatus.vue?vue&type=template&id=7a8c4a60&scoped=true&"
import script from "./vat-currentStatus.vue?vue&type=script&lang=ts&"
export * from "./vat-currentStatus.vue?vue&type=script&lang=ts&"
import style0 from "./vat-currentStatus.vue?vue&type=style&index=0&id=7a8c4a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8c4a60",
  null
  
)

export default component.exports